import {
    ShoppingBasket,
    Check,
    LoaderCircle,
} from "lucide-react";

import { useCart } from "../../context/CartContext";
import { useState } from "react";
import toast from "react-hot-toast";
import GiftModal from "../../components/product/GiftModal/GiftModal";
import { validatePurchase } from "../../services/purchaseService";
import { useNavigate } from "react-router-dom";
import ShoppingBasketPlus from "./ShoppingBasketPlus";

export default function CartControl({ product }) {

    const {
        addToCart,
        getCartItem,
    } = useCart();

    const [isAdding, setIsAdding] =
        useState(false);

    const [showGiftModal, setShowGiftModal] =
        useState(false);

    const [selectedGift, setSelectedGift] =
        useState(null);

    const [availableGifts, setAvailableGifts] =
        useState([]);


    const variationId =
        product.variationId ??
        product.variation_id;


    const cartItem = getCartItem(
        product.id,
        variationId
    );


    const isInCart =
        Boolean(cartItem);

    const navigate = useNavigate();

    const isOutOfStock =
        product.inStock !== true ||
        Number(product.stock) <= 0;


    /*
    |--------------------------------------------------------------------------
    | Add simple product
    |--------------------------------------------------------------------------
    */

    const addSimpleProduct = async (
        purchaseData = null,
        gift = null
    ) => {

        await addToCart({

            ...product,

            qty: 1,

            selectedVariation: {

                variationId,

                quantity:
                    purchaseData?.inventory?.stock ??
                    product.stock,

                price:
                    purchaseData?.price?.original ??
                    product.lowestPrice,

                salePrice:
                    purchaseData?.price?.sale ??
                    product.lowestSalePrice,

                finalPrice:
                    purchaseData?.price?.final ??
                    product.lowestSalePrice ??
                    product.lowestPrice,


                isExpired:
                    purchaseData?.inventory?.expired ??
                    false,

                inStock:
                    purchaseData?.inventory?.inStock ??
                    product.inStock,

            },

            selectedGift: gift,

        });

    };


    /*
    |--------------------------------------------------------------------------
    | Basket click
    |--------------------------------------------------------------------------
    */

    const handleClick = async (event) => {

        event.preventDefault();

        event.stopPropagation();


        /*
        |--------------------------------------------------------------------------
        | Already in cart
        |--------------------------------------------------------------------------
        */

        if (isInCart) {

            return <Check />;

        }

        if (isOutOfStock) {

            return (

                <button
                    type="button"
                    className="basket-control basket-disabled"
                    disabled
                    title="این محصول موجود نیست"
                >

                    {/* <ShoppingBasket
                size={20} stroke={"#832865"}
            />  */}

                    <ShoppingBasket size={20} stroke={"rgb(212, 212, 212)"} />

                </button>

            );

        }


        /*
        |--------------------------------------------------------------------------
        | Product with multiple variations
        |--------------------------------------------------------------------------
        */

        if (
            product.attributeCount > 1
        ) {

            navigate(`/product/${product.slug}`);

            return;

        }


        try {

            setIsAdding(true);


            /*
            |--------------------------------------------------------------------------
            | Validate current product
            |--------------------------------------------------------------------------
            |
            | This is important because gifts, stock,
            | price, promotion, and expiration can change.
            |
            */

            const purchaseData =
                await validatePurchase({

                    productId:
                        product.id,

                    variationId,

                    quantity: 1,

                });


            const currentGifts =
                purchaseData.gifts ?? [];


            /*
            |--------------------------------------------------------------------------
            | Current gifts exist
            |--------------------------------------------------------------------------
            */

            if (
                product.hasGift &&
                currentGifts.length > 0
            ) {

                setAvailableGifts(
                    currentGifts
                );

                setShowGiftModal(
                    true
                );

                return;

            }


            /*
            |--------------------------------------------------------------------------
            | No gifts
            |--------------------------------------------------------------------------
            */

            await addSimpleProduct(
                purchaseData,
                null
            );

        } catch (error) {

            toast.error(

                error.response?.data?.message ||
                "امکان افزودن محصول وجود ندارد."

            );

        } finally {

            setIsAdding(false);

        }

    };


    /*
    |--------------------------------------------------------------------------
    | Confirm selected gift
    |--------------------------------------------------------------------------
    */

    const handleConfirmGift = async () => {

        if (!selectedGift) {

            toast.error(
                "لطفاً یک هدیه انتخاب کنید."
            );

            return;

        }


        try {

            setIsAdding(true);


            /*
            |--------------------------------------------------------------------------
            | Add product with selected gift
            |--------------------------------------------------------------------------
            */

            await addSimpleProduct(
                null,
                selectedGift
            );


            setShowGiftModal(
                false
            );

            setSelectedGift(
                null
            );

            setAvailableGifts(
                []
            );

        } catch (error) {

            toast.error(

                error.response?.data?.message ||
                "امکان افزودن محصول وجود ندارد."

            );

        } finally {

            setIsAdding(false);

        }

    };


    /*
    |--------------------------------------------------------------------------
    | Already in cart
    |--------------------------------------------------------------------------
    */

    if (isInCart) {

        return (

            <span
                className="basket-check"
                onClick={(event) => {

                    event.preventDefault();

                    event.stopPropagation();

                }}
            >

                <Check size={20} />

            </span>

        );

    }


    return (

        <>

            <button
                type="button"
                className="basket-control"
                onClick={handleClick}
                disabled={isAdding}
            >

                {isAdding ? (

                    <LoaderCircle
                        size={20}
                        className="quantity-spinner"
                    />

                ) : (

                    // <ShoppingBasket  size={20}  />
                    <ShoppingBasketPlus />



                )}

            </button>


            {showGiftModal && (

                <GiftModal

                    gifts={
                        availableGifts
                    }

                    selectedGift={
                        selectedGift
                    }

                    setSelectedGift={
                        setSelectedGift
                    }

                    onClose={() => {

                        setShowGiftModal(
                            false
                        );

                        setSelectedGift(
                            null
                        );

                        setAvailableGifts(
                            []
                        );

                    }}

                    onConfirm={
                        handleConfirmGift
                    }

                />

            )}

        </>

    );

}